import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../auth";
import { VerifyBanner } from "./VerifyBanner";

export function TopBar({ children }: { children?: ReactNode }) {
  const { user, logout } = useAuth();
  return (
    <>
      <header className="topbar">
        <Link to="/" className="brand">
          <span className="brand-mark" aria-hidden>
            A
          </span>
          <span className="brand-name">AI Courses</span>
        </Link>
        <div className="topbar-middle">{children}</div>
        {user && (
          <div className="topbar-user">
            <span className="user-name" title={user.email}>
              {user.name}
            </span>
            <button className="btn btn-ghost btn-sm" onClick={() => void logout()}>
              Sign out
            </button>
          </div>
        )}
      </header>
      <VerifyBanner key={user?.id ?? 0} />
    </>
  );
}
